import { Auth0Context, initialContext, type Auth0ContextInterface } from "@auth0/auth0-react";
import type { ReactNode } from "react";

const DEV_USER = {
  sub: "dev-user",
  name: "Dev User",
  email: "dev@localhost",
  given_name: "Dev",
  family_name: "User",
};

const bypassContext = {
  ...initialContext,
  isLoading: false,
  isAuthenticated: true,
  user: DEV_USER,
  error: undefined,
  getAccessTokenSilently: async () => "",
  loginWithRedirect: async () => undefined,
  loginWithPopup: async () => undefined,
  logout: () => undefined,
} as unknown as Auth0ContextInterface;

export function DevAuthBypassProvider({ children }: { readonly children: ReactNode }) {
  return <Auth0Context.Provider value={bypassContext}>{children}</Auth0Context.Provider>;
}
